import { HeaderTop } from './HeaderTop';
import { Modal } from 'components-antd';
import { Icons as Icon } from '../Icons/Icons';

import { Button } from 'components';
import styles from './styles.module.scss';
import { useEffect, useState } from 'react';
import { Columns } from '../Columns';
import { useDispatch, useSelector } from 'react-redux';
import { getSymphonyColumns, getSymphonyPreferencesData } from 'store/selectors/symphony';
import { requestUpdateColumnsAction } from 'store/actions/symphony';
import { requestUpdateSymphonyPreferencesEffect } from 'store/effects';

export const LocalHeader = () => {
  const dispatch = useDispatch();
  const selectedColumns = useSelector(getSymphonyColumns);
  const { preferences, isPending } = useSelector(getSymphonyPreferencesData);

  const [columns, setColumns] = useState(selectedColumns);
  const [open, setOpen] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    setFirstLoad(false);
    if (!isPending && !preferences && !firstLoad) setOpen(true);
  }, [preferences, isPending]);

  return (
    <div className={styles.symphonyHeader}>
      <HeaderTop />
      <Modal
        open={open}
        width={675}
        footer={null}
        onCancel={() => {
          setOpen(false);
        }}
        destroyOnClose
        className={styles.symphonyModal}
      >
        <div className={styles.content}>
          <p className={styles.title}>{`Let's set up Symphony!`}</p>
          <div className={styles.scrollable}>
            <Icon className={styles.icon} variant={Icon.ELLIPSE} />
            <p className={styles.subtitle}>
              Symphony is your at-a-glance view of what your team is actively working on. Start by
              selecting the sections and fields you want to see.
              <br />
              <br />
              If you change your mind, you can always update your selections later.
            </p>
            <Columns columns={columns} setColumns={setColumns} className={styles.noScroll} />
          </div>
          <div className={styles.buttonContainer}>
            <Button
              isPending={false}
              className={styles.button}
              onClick={() => {
                setOpen(false);
                dispatch(requestUpdateColumnsAction(columns));
                dispatch(
                  requestUpdateSymphonyPreferencesEffect(
                    Object.values(columns)
                      .flat()
                      .map((val) => val),
                  ),
                );
              }}
              title={'Continue'}
              disabled={false}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
